<template>
  <header class="outer pickup" v-if="item.modulabholenueberschrift">
    <div class="pickup__stage" :style="backgroundImage">
      <div class="container">
        <div class="pickup__text">
          <h1 class="pickup__title">
            <span class="headline" v-html="item.modulabholenueberschrift"></span>
          </h1>
          <div v-html="item.modulabholentext"></div>
          <a
            v-if="item.modulabholenbutton.url"
            :href="item.modulabholenbutton.url"
            :target="item.modulabholenbutton.target"
            class="button button--cat1 button--large"
            v-html="item.modulabholenbutton.text"
          >
          </a>
        </div>
      </div>
    </div>

    <div class="container pickup__media" v-if="hatBilderGalerie">
      <div class="slider lc-m">
        <figure
          class="slider__item"
          v-for="bild in item.modulabholenbildergalerie.bildergalerie"
          :key="bild.url"
        >
          <img class="slider__img" :href="bild.url" :alt="bild.alt" />
          <figcaption class="slider__caption" v-if="bild.text">
            <span class="caption__img-info" v-html="bild.text"></span>
          </figcaption>
        </figure>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ModulAbholen',
  data() {
    return {
      item: this.context.item,
    };
  },
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    hatBilderGalerie() {
      return this.item.modulabholenbildergalerie.bildergalerie;
    },
    backgroundImage: function () {
      if (this.context.item.modulabholenbild.url)
        return 'background-image: url(' + this.context.item.modulabholenbild.url + ');';
      return '';
    },
  },
};
</script>
